
const dafaultState = {
    expandCreateDSType: true,
    expandCreateDSTSVerify: false,
    signatureType: "detached",
    embedSignatureTs: "true",
    embedSignatureTsChecked: true,
    embedDataTs: "true",
    embedDataTsChecked: true,
    embedCertificateType: "signerAndCaCert",
    signatureTsVerifyOption: "ignore",
    dataTsVerifyOption: "ignore",
    tsAdditionalVerifying: false,
    dataToSignQualifier: "notSignedBefore",
    duplicateSign: false,
    caId: null,
    cadesType: "CAdESBES",
    expandCreateDSCadesType: false
}

const createDSOptionsReducer = (state = dafaultState, { type, payload }) => {

    switch (type) {
    	case 'EXPAND_CREATE_DS_TYPE': {
		    return {
		        ...state,
		        expandCreateDSType: payload
		    }
		}

        case 'EXPAND_CREATE_DS_TS_VERIFY': {
            return {
                ...state,
                expandCreateDSTSVerify: payload
            }
        }

        case 'EXPAND_CREATE_DS_CADES_TYPE': {
            return {
                ...state,
                expandCreateDSCadesType: payload
            }
        }

        case 'SET_DS_SIGNATURE_TYPE': {
            return {
                ...state,
                signatureType: payload
            }
        }

        case 'SET_ADD_DS_TO_EXIST': {
            return {
                ...state,
                dataToSignQualifier: payload
            }
        }

        case 'SET_DUPLICATE_SIGN': {
            return {
                ...state,
                duplicateSign: payload
            }
        }

        case 'ADD_DATA_TS': {
            return {
                ...state,
                embedDataTsChecked: payload.checked,
                embedDataTs: payload.value
            }
        }

        case 'ADD_DS_TS': {
            return {
                ...state,
                embedSignatureTsChecked: payload.checked,
                embedSignatureTs: payload.value
            }
        }

        case 'SET_CA_ID': {
            return {
                ...state,
                caId: payload
            }
        }

        case 'DS_TS_CHECK': {
            return {
                ...state,
                embedCertificateType: payload
            }
        }

        case 'SET_CADES_TYPE': {
            return {
                ...state,
                cadesType: payload
            }
        }

        default:
            return state;
    }

}

export default createDSOptionsReducer





// WEBPACK FOOTER //
// ./src/reducers/createDSOptionsReducer.js